export default {
    CHANGE_ROUTE(state, value) {
        state.isRouting = value;
    },
    TOGGLE_TOOLBAR_BACK_BTN(state, value) {
        state.isToolbarBackBtnShow = !!value;
    },
    CHANGE_PAGE_TITLE(state, value) {
        state.pageTitle = value;
    },
    CHANGE_PAGE_LOADING(state, value) {
        state.pageLoading = value;
    },
    UPDATE_QUERY_PARAMS(state, obj) {
        state.params = Object.assign({}, state.params, obj);
        return Promise.resolve(state.params);
    },
    CHANGE_AUTH_VERIFIED(state, value) {
        state.authVerifiedType = value;
    },
    CHANGE_PAGE_PARENT(state, value) {
        state.pageParent = value;
    },
    SET_SECURITIES(state, obj) {
        state.securities = [
            {
                type: "mobile",
                value: obj.mobile || "",
                setted: !!obj.mobile
            },
            {
                type: "email",
                value: obj.email || "",
                setted: !!obj.email
            },
            {
                type: "question",
                value: obj.qa || [],
                setted: Array.isArray(obj.qa) && !!obj.qa.length
            }
        ];
    },
    TOGGLE_KEYBOARD(state, value) {
        state.isKeyboardOpen = value;
    },
    COMMIT_WEB_VIEW(state, { method, callback }) {
        let win = window;
        if (state.params.platform === "ios") {
            win.webkit.messageHandlers[method].postMessage(null);
        } else if (state.params.platform === "android") {
            win.WebViewJavascriptBridge.callHandler(method, null, callback);
        }
    },
    SET_LANDSCAPE(state, value) {
        state.landscape = value;
    }
};
